import authService from './authService';
import config from '../config';

const STT_API_PREFIX = '/api/v1/stt';

/**
 * Sends an audio file to the backend for transcription and submission to a chat session.
 * The API responds immediately with 202 Accepted, and the transcribed message
 * will be sent via SSE to the specified session.
 *
 * @param {string} sessionId The ID of the chat session to post the message to.
 * @param {Blob} audioBlob The audio blob from the recording API.
 * @param {string} [filename='recording.webm'] The filename to use for the upload.
 * @returns {Promise<object>} A promise that resolves with the success response from the API.
 * @throws {Error} If the request fails.
 */
export const transcribeAndSubmitAudio = async (sessionId, audioBlob, filename = 'recording.webm') => {
  if (!sessionId) {
    throw new Error("Session ID is required to submit audio for transcription.");
  }
  // FIX: Corrected the API endpoint path to match the backend router.
  const url = `${config.API_BASE_URL}${STT_API_PREFIX}/${sessionId}/transcribe-async`;

  console.log(`[sttApi] Submitting audio to session ${sessionId} at: ${url}`);

  const audioFile = new File([audioBlob], filename, { type: audioBlob.type });
  const formData = new FormData();
  // FIX: Changed form data key from 'file' to 'audio_file' to match backend expectation.
  formData.append('audio_file', audioFile);

  try {
    const response = await authService.authFetch(url, {
      method: 'POST',
      body: formData,
    });

    if (response.status !== 202) {
      const errorData = await response.json().catch(() => ({ detail: 'Failed to submit audio for transcription' }));
      throw new Error(errorData.detail || `API Error (${response.status}): Failed to submit audio`);
    }

    const data = await response.json();
    console.log('[sttApi] Audio submission accepted:', data);
    return data;
  } catch (error) {
    console.error('[sttApi] Error during audio submission:', error);
    // FIX: Updated function name in error tracking.
    authService.trackNetworkError('transcribeAndSubmitAudio', error);
    throw error;
  }
};